import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { LocalStorageProperties } from '../../shared/enums/local-storage-properties.enum';
import localStorageService from '../../shared/services/local-storage/local-storage.service';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { FirmwareRequestDto } from '../dtos/firmware-request.dto';
import { FirmwareRequestModel } from '../models/firmware-request-model';
import { mapFirmwareRequestModelToFirmwareRequestDto } from '../utils/mapping/mapping.util';

export const saveFirmware = createAsyncThunk<
  number,
  FirmwareRequestModel,
  Record<string, unknown>
>('firmware/save-firmware', async (firmwareSave): Promise<number> => {
  const mandantId = localStorageService.get(
    LocalStorageProperties.SELECTED_MANDANT
  ) as string;

  const requestDto: FirmwareRequestDto =
    mapFirmwareRequestModelToFirmwareRequestDto(firmwareSave);

  const url = createPathParams<'mandantId'>(Endpoints.FIRMWARE_BY_MANDANT_ID, {
    mandantId: parseInt(mandantId, 10),
  });

  const resp: AxiosResponse<number> = await axiosInstance.post(
    url,
    requestDto,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return resp.data;
});
